/**
 * 採購單狀態 → 顯示（P1.5-B）
 *
 * ⚠️ **狀態機本身唔喺呢度** —— 一律由 `@coeldery/purchase-order` 出（`nextStatuses()`／`canTransition()`）。
 *    本檔只負責「狀態 → i18n key / badge 色調」，兩頁（採購／訂單）共用。
 */
import type { PurchaseStatus } from './api';

const LABEL: Record<PurchaseStatus, string> = {
  draft: 'po.status.draft',
  sent: 'po.status.sent',
  ack: 'po.status.ack',
  shipped: 'po.status.shipped',
  received: 'po.status.received',
  closed: 'po.status.closed',
  cancelled: 'po.status.cancelled',
};

const TONE: Record<PurchaseStatus, 'ok' | 'info' | 'warn' | 'off'> = {
  draft: 'off',
  sent: 'info',
  ack: 'info',
  shipped: 'warn',
  received: 'warn',
  closed: 'ok',
  cancelled: 'off',
};

export const poStatusLabel = (status: PurchaseStatus | string): string =>
  LABEL[status as PurchaseStatus] ?? 'po.status.draft';

export const poStatusTone = (status: PurchaseStatus | string): 'ok' | 'info' | 'warn' | 'off' =>
  TONE[status as PurchaseStatus] ?? 'info';
